import './InitiativesList.css'
import { Fragment } from 'react';
import SelectDropDown from './SelectDropDown';
import { Col, Row } from 'react-bootstrap';
import InitiativeCard from '../../UI/initiative-card/InitiativeCard';

const InitiativesList = () => {
    

    return (
            <Fragment>
                <div className="row courses-top-head mb-md-3 align-items-center">
                
                    <div className='col-6'>
                        <p>Initiative List (200 Initiative) </p>
                    </div>

                    <div className="col-6 ml-auto">
                        <div className='row'>
                            <div className='col-3 d-flex align-items-center sort-container'>
                                <span>Sort By</span>
                            </div>
                            <div className='col-4 p-0'>
                                <SelectDropDown />
                            </div>
                        </div>
                    </div>

                </div>

                <div className="courses-list">
                <Row>
                    <Col lg="4">
                        <InitiativeCard />
                    </Col>
                    <Col lg="4">
                        <InitiativeCard />
                    </Col>
                    <Col lg="4">
                        <InitiativeCard />
                    </Col>
                    <Col lg="4">
                        <InitiativeCard />
                    </Col>
                    <Col lg="4">
                        <InitiativeCard />
                    </Col>
                    <Col lg="4">
                        <InitiativeCard />
                    </Col>
                    <Col lg="4">
                        <InitiativeCard />
                    </Col>
                    <Col lg="4">
                        <InitiativeCard />
                    </Col>
                </Row>
                </div>
            </Fragment>
        
    )
}

export default InitiativesList
